import { create } from 'zustand';

interface UseLawFirmStore {
    selectedLawFirmId: number | undefined;
    setSelectedLawFirmId: (lawFirmId: number | undefined) => void;
}

const useLawFirmStore = create<UseLawFirmStore>((set) => ({
    selectedLawFirmId: undefined,
    setSelectedLawFirmId: (lawFirmId) => set({ selectedLawFirmId: lawFirmId }),
}));

export default useLawFirmStore;
